import React, { Component } from 'react';

const defaultProps = {
  person: {}
};

class Person extends Component {
  render() {
    const person = this.props.person;
    let advisorTitle;
    if (person.title) {
      advisorTitle = '| ' + person.title;
    }

    return (
      <div className="row row-no-gutters office__lead-person">
        <div className="col">
          <div
            className="office__lead-person-image"
            data-responsive-background-image
            style={{ backgroundImage: `url(${person.image ? person.image : ''})` }}
          >
            {person.image ? (
              <img src={person.image} className="img-responsive" alt={`${person.name} ${person.lastname}`} />
            ) : null}
          </div>
          <div className="office__lead-person-desc">
            <b>{person.jobTitle}</b>
            <br />
            {person.name} {person.lastname} {advisorTitle}
            <br />
            {person.email ? (
              <a href={`mailto:${person.email}`} className="">
                {person.email}
              </a>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}
Person.defaultProps = defaultProps;

export default Person;
